// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description-about-service-fee[data-v-2257f55c]{font-size:10px;padding-left:10px}", ""]);
// Exports
module.exports = exports;
